<template>
  <div :class="['page-binding', loginType ? 'page-binding-login' : 'page-binding-normal']">
    <div class="container">
      <div class="page-header">
        <h2>{{ title }}</h2>
      </div>
      <div class="page-body">
        <verify v-if="action === 'change' && step === 1" :value="value" :smsType="type" @next="onNext"></verify>
        <action v-else :action="action" :value="value" :type="type" :event="event" :loginType="loginType" :codeToken="token"></action>
      </div>
      <div class="page-footer" v-if="action === 'change' && step === 1">
        <div class="mod-tip" v-if="userType === 0 ">
          <a-icon type="exclamation-circle" theme="filled" />若以上联系方式已失效，您可以使用 <router-link :to="`/authenticate?type=${type}`">线上实名认证方式</router-link> 修改{{ type === 'mobile' ? '手机' : '邮箱' }}信息，或致电{{ app.name }}客服热线{{ app.hotline }}协助您更新联系方式。
        </div>
        <div class="mod-tip" v-else>
          <a-icon type="exclamation-circle" theme="filled" />若以上联系方式已失效，您可以致电{{ app.name }}客服热线{{ app.hotline }}协助您更新联系方式。
        </div>
      </div>
      <div class="warn-tips">
          温馨提示：为了您的账户安全，金鹏会员初次登录请验证本人手机号信息
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string'
import Verify from './components/Verify'
import Action from './components/Form'
import fromApp from '@/utils/from'
import './index'

export default {
  data () {
    return {
      action: 'bind',
      type: 'mobile',
      value: '',
      step: 1,
      token: '',
      finalToken: '',
      event: 0,
      // 通过其判断是登录入口过来的还是普通入口，登录入口进来没有侧边栏
      loginType: '',
      userType: 0,
      app: null
    }
  },
  computed: {
    title () {
      const { action, type } = this

      if (action === 'bind') {
        return type === 'mobile' ? '手机号码绑定' : '邮箱绑定'
      } else {
        return type === 'mobile' ? '修改手机' : '修改邮箱'
      }
    }
  },
  created () {
    const params = queryString.parse(location.search)

    this.type = params.type || 'mobile'
    this.action = params.action || 'bind'
    this.value = params.value || ''
    this.event = parseInt(params.event) === 1 ? 1 : 0
    this.loginType = params.loginType || ''

    const userInfo = this.$ls.get('USER_CENTER_INFO')

    if (userInfo) {
      this.userType = userInfo.userType
    }

    this.app = fromApp()
  },
  methods: {
    onNext (data) {
      this.token = data
      this.$nextTick(() => {
        this.step = this.step + 1
      })
    },
    onGetFinalToken (value) {
      this.finalToken = value
    }
  },
  components: {
    Action,
    Verify
  }
}
</script>
